import React, { Fragment, useEffect, useState, useRef, useCallback } from 'react';
import {
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
  getFilteredRowModel,
  getPaginationRowModel,
  getFacetedUniqueValues
} from '@tanstack/react-table';
import { useVirtualizer } from '@tanstack/react-virtual';
import { ArrowPathIcon, PencilIcon, TrashIcon, PlusCircleIcon, FunnelIcon, EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
import { initialpageSize } from '../Common/Contants';
import InputModal from '../Common/InputModal';
import Popup from '../Common/Popup';
import ConfirmationPopup from '../Common/ConfirmationPopup';
import axios from 'axios';
import { API_URL, FUNCTION_BASE_URL, PROJECT_URL } from '../../imports'
import { DebouncedInput, ProjectStatusFilter, SelectSelectedClientBasedTextFilter } from '../Common/Filters';
import FetchingDataLoader from '../Common/FetchingDataLoader';
import { handleApiError } from '../Common/APIUtils';
import PageSizeDropdown from '../Common/PageSizeDropdown';
import { formattedDate } from '../Common/CommonUtils';
import { Menu, Transition } from '@headlessui/react';
import { Portal } from "react-portal";
import Pagination from '../Common/Pagination';

import { jwtDecode } from "jwt-decode";

const token = localStorage.getItem("token");
const user = token ? jwtDecode(token) : {};

export default function ProjectSetup() {
  let [isOpen, setIsOpen] = useState(false);
  // let [rowData, setRowData] = useState([]);
  let [rowData, setRowData] = useState({
    project_name: '',
    group_id: null,
    description: '',
    gpt_key: '',
    pyannote_key: '',
    proj_key_name: '',
    azure_param: null,
    proj_tag_code: null,
    project_code: null,
    client_code: ''
  });
  let [groups, setGroups] = useState([]);
  let [tags, setTags] = useState([]);
  let [selectedTag, setSelectedTag] = useState("");
  let [edit, setEdit] = useState(false);
  const [Loader, setLoader] = useState(true)
  let [isOpenPopup, setIsOpenPopup] = useState(false);
  let [msg, setMsg] = useState(false);
  let [isSuccess, setIsSuccess] = useState(false);
  let [editGPT, setEditGPT] = useState(false);
  let [editPyannote, setEditPyannote] = useState(false);
  let [client, setClient] = useState([]);
  let [assignMe, setAssignMe] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0 });
  const [activeDropdown, setActiveDropdown] = useState(null);
  const buttonRefs = useRef({});
  const dropdownRef = useRef(null);
  const [selectedOption, setSelectedOption] = useState('automation');
  const [originalKeyGeneration, setOriginalKeyGeneration] = useState('automation');
  const [enableAzure, setEnableAzure] = useState(false);
  const [modalKey, setModalKey] = useState(0);
  const [modalContentKey, setModalContentKey] = useState(0);
  const [azureDeploymentName, setAzureDeploymentName] = useState("");

  const calculatePosition = useCallback((id) => {
    const buttonRef = buttonRefs.current[id];
    if (buttonRef) {
      const rect = buttonRef.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
      });
      setActiveDropdown((prev) => (prev === id ? null : id));
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    const handleKeyDown = (event) => {
      const keysToCloseDropdown = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp'];
      if (keysToCloseDropdown.includes(event.key)) {
        setActiveDropdown(null);
      }
    };
    const handleScroll = () => {
      setActiveDropdown(null);
    };

    if (activeDropdown !== null) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleKeyDown);
      window.addEventListener("scroll", handleScroll, true);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [activeDropdown]);


  function closePopup() {
    setIsOpenPopup(false);
  }

  function openPopup() {
    setIsOpenPopup(true);
  }

  // function closeModal() {
  //   setIsOpen(false);
  //   setRowData([]);
  // }
  function closeModal() {
    setIsOpen(false);
    
    // Clear all form-related states
    setEdit(false);
    setEditGPT(false);
    setEditPyannote(false);
    setSelectedOption('manual');
    setOriginalKeyGeneration('automation');
    setEnableAzure(false);
    setSelectedTag("");
    
    if (localStorage.getItem('level') === '2') {
      setAssignMe(false);
    }
    
    // Clear rowData completely with ALL fields
    setRowData({
      project_name: '',
      group_id: null,
      description: '',
      gpt_key: '',
      pyannote_key: '',
      proj_key_name: '',
      azure_param: null,
      proj_tag_code: null,
      project_code: null  // ✅ Add this field
    });
  }

  // function openModal(e, option) {
  //   const mappedData = {
  //     ...e,
  //     project_name: e.name || e.project_name, // Map 'name' to 'project_name'
  //     // proj_grp_code: e.group_id || e.proj_grp_code, // Map 'group_id' to 'proj_grp_code'
  //     group_id: e.group_id || '',
  //   };
  //   setRowData(mappedData); 
  //   if (option === 'edit') {
  //     if (localStorage.getItem('level') === '2') { setAssignMe(e.assignMyself) }
  //     setEditGPT(false);
  //     setEditPyannote(false);
  //     setEdit(true);
  //     setSelectedTag(e.proj_tag_code ? JSON.parse(e.proj_tag_code?.replace(/'/g, '"'))[0] : "");
  //     setSelectedOption(e.process_type);
  //     setOriginalKeyGeneration(e.process_type);
  //     setEnableAzure(e.azure_enabled);
  //   }
  //   else if (option === 'create') {
  //     if (localStorage.getItem('level') === '2') { setAssignMe(false) }
  //     setEditGPT(true);
  //     setEditPyannote(true);
  //     setEdit(false);
  //     setSelectedOption("automation");
  //     setOriginalKeyGeneration("automation");
  //     setEnableAzure(false);
  //   }
  //   setIsOpen(true);
  // }

  // const ReloadData = async (loadprops) => {
  //   setLoader(loadprops);
  //   axios.get(`${PROJECT_URL}/projects/activegrouptag`, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //     },
  //     params: {
  //       client: sessionStorage.getItem('client')
  //     }
  //   })
  //     .then((response) => {
  //       setGroups(response.data.data.project_grp_list);
  //       setTags(response.data.data.project_tag_list);
  //     })
  //     .catch((error) => {
  //       const errorMessage = handleApiError(error);
  //       setMsg(errorMessage);
  //       openPopup();
  //     });
  //   axios.get(`${PROJECT_URL}/projects`, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //     },
  //     params: {
  //       client: sessionStorage.getItem('client')
  //     }
  //   })
  //     .then((response) => {
  //       setData(response.data.data);
  //     })
  //     .catch((error) => {
  //       const errorMessage = handleApiError(error);
  //       setMsg(errorMessage);
  //       openPopup();
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         setLoader(false);
  //       }, 100);
  //     });
  // };

  // const ReloadData = async (loadprops) => {
  //   setLoader(loadprops);
    
  //   // Fetch active groups and tags
  //   axios.post(`${PROJECT_URL}/projects/groups/list`, {
  //     userInfo: {
  //       _id: sessionStorage.getItem("userid"),
  //       clientId: sessionStorage.getItem('client'),
  //       role: sessionStorage.getItem('role')
  //     },
  //     payload: {}
  //   }, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //     }
  //   })
  //   .then((response) => {
  //     // Filter only active groups
  //     const activeGroups = response.data.filter(g => g.status === 'active');
  //     setGroups(activeGroups);
  //   })
  //   .catch((error) => {
  //     const errorMessage = handleApiError(error);
  //     setMsg(errorMessage);
  //     openPopup();
  //   });
    
  //   // Fetch projects
  //   axios.post(`${PROJECT_URL}/projects/list`, {
  //     userInfo: {
  //       _id: sessionStorage.getItem("userid"),
  //       clientId: sessionStorage.getItem('client'),
  //       role: sessionStorage.getItem('role')
  //     },
  //     payload: {}
  //   }, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //     }
  //   })
  //   .then((response) => {
  //     console.log("Projects data:", response.data);
  //     setData(response.data);
  //   })
  //   .catch((error) => {
  //     const errorMessage = handleApiError(error);
  //     setMsg(errorMessage);
  //     openPopup();
  //   })
  //   .finally(() => {
  //     setTimeout(() => {
  //       setLoader(false);
  //     }, 100);
  //   });
  // };

  // function openModal(e, option) {
  //   console.log("Opening modal with data:", e);
    
  //   const mappedData = {
  //     ...e,
  //     project_name: e.name || e.project_name,
  //     // group_id: e.group_id || e.proj_grp_code || '',
  //     group_id: e.group_id ?? null,
  //     // ✅ CRITICAL: Ensure project_code is preserved
  //     project_code: e.project_code || e.id
  //   };
    
  //   console.log("Mapped data:", mappedData);
  //   setRowData(mappedData);
    
  //   if (option === 'edit') {
  //     if (localStorage.getItem('level') === '2') { 
  //       setAssignMe(e.assignMyself) 
  //     }
  //     setEditGPT(false);
  //     setEditPyannote(false);
  //     setEdit(true);
  //     setSelectedTag(e.proj_tag_code ? JSON.parse(e.proj_tag_code?.replace(/'/g, '"'))[0] : "");
  //     // setSelectedOption(e.process_type);
  //     setSelectedOption("manual");
  //     setOriginalKeyGeneration(e.process_type);
  //     setEnableAzure(e.azure_enabled);
  //   }
  //   else if (option === 'create') {
  //     if (localStorage.getItem('level') === '2') { 
  //       setAssignMe(false) 
  //     }
  //     setEditGPT(true);
  //     setEditPyannote(true);
  //     setEdit(false);
  //     // setSelectedOption("automation");
  //     setSelectedOption("manual");
  //     setOriginalKeyGeneration("automation");
  //     setEnableAzure(false);
  //   }
  //   setIsOpen(true);
  // }

  // function openModal(e, option) {
  //   console.log("Opening modal with data:", e);
    
  //   const mappedData = {
  //     ...e,
  //     project_name: e.name || e.project_name,
  //     group_id: e.group_id ?? null,
  //     // ✅ CRITICAL FIX: Ensure project_code is always preserved
  //     project_code: e.project_code || e.id,  // Use project_code, fallback to id if needed
  //     // Also preserve other fields that might be used in edit
  //     status: e.status,
  //     description: e.description || "",
  //     gpt_key: e.gpt_key || null,
  //     pyannote_key: e.pyannote_key || null,
  //     proj_key_name: e.proj_key_name || null,
  //     azure_param: e.azure_param || null,
  //     proj_tag_code: e.proj_tag_code || null
  //   };
    
  //   console.log("Mapped data:", mappedData);
  //   console.log("✅ project_code:", mappedData.project_code);  // Debug log
    
  //   setRowData(mappedData);
    
  //   if (option === 'edit') {
  //     if (localStorage.getItem('level') === '2') { 
  //       setAssignMe(e.assignMyself) 
  //     }
  //     setEditGPT(false);
  //     setEditPyannote(false);
  //     setEdit(true);
  //     setSelectedTag(e.proj_tag_code ? JSON.parse(e.proj_tag_code?.replace(/'/g, '"'))[0] : "");
  //     setSelectedOption("manual");
  //     setOriginalKeyGeneration(e.process_type);
  //     setEnableAzure(e.azure_enabled);
  //   }
  //   else if (option === 'create') {
  //     // Clear all fields for create mode
  //     setRowData({
  //       project_name: '',
  //       group_id: null,
  //       description: '',
  //       gpt_key: '',
  //       pyannote_key: '',
  //       proj_key_name: '',
  //       azure_param: null,
  //       proj_tag_code: null
  //     });
  //     if (localStorage.getItem('level') === '2') { 
  //       setAssignMe(false) 
  //     }
  //     setEditGPT(true);
  //     setEditPyannote(true);
  //     setEdit(false);
  //     setSelectedOption("manual");
  //     setOriginalKeyGeneration("automation");
  //     setEnableAzure(false);
  //   }
  //   setIsOpen(true);
  // }

  function openModal(e, option) {
    if (option === 'create') {
      // Close modal first
      setIsOpen(false);
      
      // Wait for Headless UI transition to complete (300ms)
      setTimeout(() => {
        // Clear all states
        setEdit(false);
        setEditGPT(true);
        setEditPyannote(true);
        setSelectedOption("manual");
        setOriginalKeyGeneration("manual");
        setEnableAzure(false);
        setSelectedTag("");
        
        if (localStorage.getItem('level') === '2') {
          setAssignMe(false);
        }
        
        // Clear rowData
        setRowData({
          project_name: '',
          group_id: null,
          description: '',
          gpt_key: '',
          pyannote_key: '',
          proj_key_name: '',
          azure_param: null,
          proj_tag_code: null,
          project_code: null,
          client_code: ''
        });
        
        // 🔑 INCREMENT MODAL KEY - Forces complete remount
        setModalContentKey(prev => prev + 1);
        
        // Open modal after clearing
        setTimeout(() => {
          setIsOpen(true);
        }, 50);
      }, 350); // 300ms transition + 50ms buffer
      
      return;
    }

    if (option === 'edit') {
      const mappedData = {
        project_name: e.name || e.project_name || '',
        group_id: e.group_id ?? null,
        project_code: e.project_code || e.id || null,
        description: e.description || '',
        gpt_key: e.gpt_key || '',
        pyannote_key: e.pyannote_key || '',
        proj_key_name: e.proj_key_name || '',
        azure_param: e.azure_param || null,
        proj_tag_code: e.proj_tag_code || null,
        client_code: e.client_code || ''
      };

      setRowData(mappedData);
      setEdit(true);
      setEditGPT(false);
      setEditPyannote(false);
      setSelectedOption(e.process_type || "manual");
      setOriginalKeyGeneration(e.process_type || "manual");
      setEnableAzure(e.azure_enabled || false);
      setSelectedTag(e.proj_tag_code ? JSON.parse(e.proj_tag_code?.replace(/'/g, '"'))[0] : "");
      
      if (localStorage.getItem('level') === '2') {
        setAssignMe(e.assignMyself || false);
      }
      
      // 🔑 INCREMENT MODAL KEY for edit too
      setModalContentKey(prev => prev + 1);
      
      setIsOpen(true);
    }
  }

  // const ReloadData = async (loadprops) => {
  //   setLoader(loadprops);
    
  //   try {
  //       const response = await axios.post(`${PROJECT_URL}/projects/list`, {
  //           userInfo: {
  //               _id: sessionStorage.getItem("userid"),
  //               clientId: sessionStorage.getItem('client'),
  //               role: sessionStorage.getItem('role')
  //           },
  //           payload: {}
  //       }, {
  //           headers: {
  //               Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //           }
  //       });
        
  //       console.log("🔄 ReloadData fetched:", response.data);
  //       console.log("🔍 Looking for project:", rowData?.project_code);
        
  //       const updatedProject = response.data.find(p => p.project_code === rowData?.project_code);
  //       console.log("🎯 Updated project found:", updatedProject);
        
  //       setData(response.data);
        
  //   } catch (error) {
  //       const errorMessage = handleApiError(error);
  //       setMsg(errorMessage);
  //       openPopup();
  //   } finally {
  //       setTimeout(() => {
  //           setLoader(false);
  //       }, 100);
  //   }
  // };

  // const handleCreateState = async () => {
  //   setIsOpen(false);
  //   const formattedProjTagCode = rowData.proj_tag_code ? [rowData.proj_tag_code] : null;
  //   const formattedProjGrpCode = rowData.proj_grp_code ? rowData.proj_grp_code : null;
  //   const formattedProjGPTKey = rowData.gpt_key ? rowData.gpt_key : null;
  //   const formattedProjPyannoteKey = rowData.pyannote_key ? rowData.pyannote_key : null;
  //   const formattedProjKeyName = rowData.proj_key_name ? rowData.proj_key_name : null;
  //   const formattedAzureParam = rowData.azure_param ? rowData.azure_param : null;

  //   let create_form = { project_name: rowData.project_name, proj_grp_code: formattedProjGrpCode, proj_tag_code: formattedProjTagCode, gpt_key: formattedProjGPTKey, pyannote_key: formattedProjPyannoteKey, azure_param: formattedAzureParam, proj_key_name: formattedProjKeyName, ...(localStorage.getItem('level') === '2' && { assignMyself: assignMe }), ...(localStorage.getItem('role') === 'ADMIN' && { client_code: rowData.client_code }), process_type: selectedOption };

  //   try {
  //     await axios
  //       .post(`${PROJECT_URL}/projects`, create_form, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         },
  //         params: {
  //           client: sessionStorage.getItem('client')
  //         }
  //       })
  //       .then((response) => {
  //         setMsg(response.data.message);
  //         setIsSuccess(true);
  //         ReloadData(false);
  //         setIsOpenPopup(true);
  //       });
  //   } catch (error) {
  //     const errorMessage = handleApiError(error);
  //     setMsg(errorMessage);
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //   }
  // };

  const ReloadData = async (loadprops) => {
    console.log("🔵 ReloadData called with loadprops:", loadprops);
    setLoader(loadprops);
    
    // Fetch active groups and tags
    try {
      const groupsResponse = await axios.post(`${PROJECT_URL}/projects/groups/list`, {
        userInfo: {
          _id: sessionStorage.getItem("userid"),
          clientId: sessionStorage.getItem('client'),
          role: sessionStorage.getItem('role')
        },
        payload: {}
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        }
      });
      
      // Filter only active groups
      const activeGroups = groupsResponse.data.filter(g => g.status === 'active');
      console.log("🔵 Loaded groups:", activeGroups.length);
      setGroups(activeGroups);
    } catch (error) {
      console.error("❌ Error loading groups:", error);
      const errorMessage = handleApiError(error);
      setMsg(errorMessage);
      openPopup();
    }
    
    // Fetch projects
    try {
      const projectsResponse = await axios.post(`${PROJECT_URL}/projects/list`, {
        userInfo: {
          _id: sessionStorage.getItem("userid"),
          clientId: sessionStorage.getItem('client'),
          role: sessionStorage.getItem('role')
        },
        payload: {}
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        }
      });
      
      console.log("✅ Projects reloaded:", projectsResponse.data);
      console.log("✅ Number of projects:", projectsResponse.data.length);
      console.log("✅ First project:", projectsResponse.data[0]);
      console.log("PROJECT API RESPONSE:", projectsResponse.data);
      // setData(projectsResponse.data);
      setData([...projectsResponse.data]);   // force new reference
      
    } catch (error) {
      console.error("❌ Error loading projects:", error);
      const errorMessage = handleApiError(error);
      setMsg(errorMessage);
      openPopup();
    } finally {
      setTimeout(() => {
        console.log("🔵 Setting loader to false");
        setLoader(false);
      }, 100);
    }
  };

  // const handleCreateState = async () => {
  //   setIsOpen(false);

  //   // ✅ Prepare complete request body
  //   const requestBody = {
  //       payload: {
  //           name: rowData.project_name || rowData.name,
  //           description: rowData.description || "",
  //           group_id: rowData.proj_grp_code || null,
  //           status: "active",
            
  //           // Add all the additional fields
  //           proj_key_name: rowData.proj_key_name || null,
  //           pyannote_key: rowData.pyannote_key || null,
  //           proj_tag_code: rowData.proj_tag_code ? [rowData.proj_tag_code] : null,
  //           gpt_key: rowData.gpt_key || null,
  //           azure_param: rowData.azure_param || null,
  //           process_type: selectedOption,  // "manual" or "automation"
  //           azure_enabled: enableAzure
  //       },
  //       userInfo: {
  //           _id: sessionStorage.getItem("userid"),
  //           clientId: sessionStorage.getItem('client'),
  //           role: sessionStorage.getItem('role')
  //       }
  //   };

  //   try {
  //       const response = await axios.post(
  //           // `${PROJECT_URL}/projects/create`,
  //           // `${PROJECT_URL}/create`,
  //           `${PROJECT_URL}/projects/create`,
  //           requestBody,
  //           {
  //               headers: {
  //                   Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //               }
  //           }
  //       );
        
  //       setMsg(response.data.message);
  //       setIsSuccess(true);
  //       // ReloadData(false);
  //       ReloadData(true); 
  //       setIsOpenPopup(true);
        
  //   } catch (error) {
  //       const errorMessage = handleApiError(error);
  //       setMsg(errorMessage);
  //       setIsSuccess(false);
  //       setIsOpenPopup(true);
  //   }
  // };

  // const handleEditState = async () => {
  //   const formattedProjTagCode = selectedTag ? [selectedTag] : null;
  //   const formattedProjGrpCode = rowData.proj_grp_code ? rowData.proj_grp_code : null;
  //   const formattedProjGPTKey = rowData.gpt_key ? rowData.gpt_key : null;
  //   const formattedProjPyannoteKey = rowData.pyannote_key ? rowData.pyannote_key : null;
  //   const formattedProjKeyName = rowData.proj_key_name ? rowData.proj_key_name : null;
  //   const formattedAzureParam = rowData.azure_param ? rowData.azure_param : null;

  //   let status = { project_name: rowData.project_name, proj_grp_code: formattedProjGrpCode, proj_tag_code: formattedProjTagCode, gpt_key: formattedProjGPTKey, pyannote_key: formattedProjPyannoteKey, azure_param: formattedAzureParam, proj_key_name: formattedProjKeyName, ...(localStorage.getItem('level') === '2' && { assignMyself: assignMe }), ...(localStorage.getItem('role') === 'ADMIN' && { client_code: rowData.client_code }), process_type: originalKeyGeneration };
  //   try {
  //     await axios
  //       .patch(`${PROJECT_URL}/projects/${rowData.project_code}`, status, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         },
  //       })
  //       .then((response) => {
  //         setIsOpen(false);
  //         setMsg(response.data.message);
  //         setIsSuccess(true);
  //         ReloadData(false);
  //         setIsOpenPopup(true);
  //       });
  //   } catch (error) {
  //     setIsOpen(false);
  //     const errorMessage = handleApiError(error);
  //     setMsg(errorMessage);
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //   }
  // };
  
  // const handleEditState = async () => {
  //   const requestBody = {
  //       payload: {
  //           // name: rowData.project_name,
  //           name: rowData.name || rowData.project_name,
  //           description: rowData.description || "",
  //           group_id: rowData.group_id || rowData.proj_grp_code || null,
  //           status: rowData.status,
            
  //           // Add all the additional fields
  //           proj_key_name: rowData.proj_key_name || null,
  //           pyannote_key: rowData.pyannote_key || null,
  //           proj_tag_code: selectedTag ? [selectedTag] : null,
  //           gpt_key: rowData.gpt_key || null,
  //           azure_param: rowData.azure_param || null,
  //           process_type: originalKeyGeneration,
  //           azure_enabled: enableAzure
  //       },
  //       userInfo: {
  //           _id: sessionStorage.getItem("userid"),
  //           clientId: sessionStorage.getItem('client'),
  //           role: sessionStorage.getItem('role')
  //       }
  //   };

  //   try {
  //       const response = await axios.put(
  //           `${PROJECT_URL}/projects/${rowData.project_code}`,
  //           requestBody,
  //           {
  //               headers: {
  //                   Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //               }
  //           }
  //       );
  //       console.log("✅ Update response:", response.data); // Add this
  //       console.log("📝 Request payload:", requestBody.payload);
  //       setIsOpen(false);

  //       // ✅ Update the specific row in the state
  //       setData(prevData => 
  //         prevData.map(item => 
  //           item.project_code === rowData.project_code 
  //             ? { 
  //                 ...item, 
  //                 name: requestBody.payload.name,
  //                 description: requestBody.payload.description,
  //                 group_id: requestBody.payload.group_id,
  //                 status: requestBody.payload.status,
  //                 proj_key_name: requestBody.payload.proj_key_name,
  //                 pyannote_key: requestBody.payload.pyannote_key,
  //                 proj_tag_code: requestBody.payload.proj_tag_code,
  //                 gpt_key: requestBody.payload.gpt_key,
  //                 azure_param: requestBody.payload.azure_param,
  //                 process_type: requestBody.payload.process_type,
  //                 azure_enabled: requestBody.payload.azure_enabled
  //               }
  //             : item
  //         )
  //       );

  //       setMsg(response.data.message || "Updated successfully");
  //       setIsSuccess(true);
  //       // ReloadData(false);
  //       // ReloadData(true); 
  //       // ✅ FIX: Reload data with a slight delay to ensure modal closes first
  //       setTimeout(() => {
  //           ReloadData(true);  // Show loader while reloading
  //       }, 100);

  //       setIsOpenPopup(true);
        
  //   } catch (error) {
  //       setIsOpen(false);
  //       const errorMessage = handleApiError(error);
  //       setMsg(errorMessage);
  //       setIsSuccess(false);
  //       setIsOpenPopup(true);
  //   }
  // };

  // const handleCreateState = async () => {
  //   setIsOpen(false);

  //   // ✅ FIX: Ensure name field is correctly populated
  //   const requestBody = {
  //       payload: {
  //           name: rowData.project_name || rowData.name,  // ✅ Check project_name first
  //           description: rowData.description || "",
  //           // group_id: rowData.group_id || rowData.proj_grp_code || null,
  //           group_id: rowData.group_id ?? null,
  //           status: "active",
            
  //           // Add all the additional fields
  //           proj_key_name: rowData.proj_key_name || null,
  //           pyannote_key: rowData.pyannote_key || null,
  //           proj_tag_code: rowData.proj_tag_code ? [rowData.proj_tag_code] : null,
  //           gpt_key: rowData.gpt_key || null,
  //           azure_param: rowData.azure_param || null,
  //           process_type: selectedOption,  // "manual" or "automation"
  //           azure_enabled: enableAzure
  //       },
  //       userInfo: {
  //           _id: sessionStorage.getItem("userid"),
  //           clientId: sessionStorage.getItem('client'),
  //           role: sessionStorage.getItem('role')
  //       }
  //   };

  //   // ✅ ADD VALIDATION: Check if name exists before sending
  //   if (!requestBody.payload.name || requestBody.payload.name.trim() === "") {
  //       setMsg('Project name is required');
  //       setIsSuccess(false);
  //       setIsOpenPopup(true);
  //       return;  // Don't proceed with API call
  //   }

  //   console.log("📤 Creating project with payload:", requestBody);

  //   try {
  //       const response = await axios.post(
  //           // `${PROJECT_URL}/projects/create`,
  //           // `${PROJECT_URL}/create`,
  //           requestBody,
  //           {
  //               headers: {
  //                   Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //               }
  //           }
  //       );
        
  //       console.log("✅ Create response:", response.data);
        
  //       setMsg(response.data.message);
  //       setIsSuccess(true);
  //       ReloadData(true); 
  //       setIsOpenPopup(true);
        
  //   } catch (error) {
  //       console.error("❌ Create error:", error);
  //       console.error("❌ Error response:", error.response?.data);
  //       const errorMessage = handleApiError(error);
  //       setMsg(errorMessage);
  //       setIsSuccess(false);
  //       setIsOpenPopup(true);
  //   }
  // };

  // const handleCreateState = async () => {
  //   setIsOpen(false);

  //   const requestBody = {
  //       name: rowData.project_name || rowData.name,
  //       description: rowData.description || "",
  //       group_id: rowData.proj_grp_code || null,
  //       status: "active",
  //       proj_key_name: rowData.proj_key_name || null,
  //       pyannote_key: rowData.pyannote_key || null,
  //       proj_tag_code: rowData.proj_tag_code ? [rowData.proj_tag_code] : null,
  //       gpt_key: rowData.gpt_key || null,
  //       azure_param: rowData.azure_param || null,
  //       process_type: selectedOption,
  //       azure_enabled: enableAzure
  //   };

  //   try {
  //       const response = await axios.post(
  //           `${PROJECT_URL}/projects/create`,
  //           requestBody,
  //           {
  //               headers: {
  //                   Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //               }
  //           }
  //       );
  //       console.log("✅ Create response:", response.data);
  //       setMsg(response.data.message);
  //       setIsSuccess(true);
  //       ReloadData(true); 
  //       setIsOpenPopup(true);
        
  //   } catch (error) {
  //       console.error("❌ Create error:", error);
  //       console.error("❌ Error response:", error.response?.data);
  //       const errorMessage = handleApiError(error);
  //       setMsg(errorMessage);
  //       setIsSuccess(false);
  //       setIsOpenPopup(true);
  //   }
  // };

  const handleCreateState = async () => {
    setIsOpen(false);

    // Validate project name is not empty
    if (!rowData.project_name || !rowData.project_name.trim()) {
      setMsg("Project name is required");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // Check for duplicate project name
    const isDuplicate = data.some(
      project => project.name.toLowerCase().trim() === rowData.project_name.toLowerCase().trim()
    );

    if (isDuplicate) {
      setMsg("A project with this name already exists");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // Validate GPT Key is mandatory
    // if (!rowData.gpt_key || !rowData.gpt_key.trim()) {
    //   setMsg("GPT Key is required");
    //   setIsSuccess(false);
    //   setIsOpenPopup(true);
    //   return;
    // }

    // ✅ Validate based on provider
    // if (enableAzure) {
    //   // Azure validation
    //   if (!rowData.azure_param?.azure_key || !rowData.azure_param.azure_key.trim()) {
    //     setMsg("Azure Key is required");
    //     setIsSuccess(false);
    //     setIsOpenPopup(true);
    //     return;
    //   }
    //   if (!rowData.azure_param?.azure_endpoint || !rowData.azure_param.azure_endpoint.trim()) {
    //     setMsg("Azure Endpoint is required");
    //     setIsSuccess(false);
    //     setIsOpenPopup(true);
    //     return;
    //   }
    //   if (!rowData.azure_param?.azure_deployment_name || !rowData.azure_param.azure_deployment_name.trim()) {
    //     setMsg("Azure Deployment Name is required");
    //     setIsSuccess(false);
    //     setIsOpenPopup(true);
    //     return;
    //   }
    // } else {
    //   // OpenAI validation
    //   if (!rowData.gpt_key || !rowData.gpt_key.trim()) {
    //     setMsg("GPT Key is required");
    //     setIsSuccess(false);
    //     setIsOpenPopup(true);
    //     return;
    //   }

    // // Validate GPT Key format if provided
    // // if (rowData.gpt_key && rowData.gpt_key.trim()) {
    //   // const gptKeyPattern = /^sk-[A-Za-z0-9]{48}$/;
    //   const gptKeyPattern = /^sk-[A-Za-z0-9_-]{20,}$/;
    //   if (!gptKeyPattern.test(rowData.gpt_key.trim())) {
    //     setMsg("Invalid GPT Key format. GPT Key should start with 'sk-' followed by 48 alphanumeric characters.");
    //     setIsSuccess(false);
    //     setIsOpenPopup(true);
    //     return;
    //   }
    // }

    // ============================================================================
    // COMPLETE VALIDATION SECTION - Replace lines 909-949 in handleCreateState
    // ============================================================================

    // Check if at least one key is provided
    const hasOpenAIKey = rowData.gpt_key && rowData.gpt_key.trim();
    const hasAzureKey = rowData.azure_param?.azure_key && rowData.azure_param.azure_key.trim();

    // Validation 1: No keys provided at all
    if (!hasOpenAIKey && !hasAzureKey) {
      setMsg("Please provide at least one API key (OpenAI or Azure) to create the project.");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // Validation 2: Azure fields validation (only if Azure key is provided)
    if (hasAzureKey) {
      if (!rowData.azure_param?.azure_endpoint || !rowData.azure_param.azure_endpoint.trim()) {
        setMsg("Azure Endpoint is required when using Azure Key.");
        setIsSuccess(false);
        setIsOpenPopup(true);
        return;
      }
      if (!rowData.azure_param?.azure_deployment_name || !rowData.azure_param.azure_deployment_name.trim()) {
        setMsg("Azure Deployment Name is required when using Azure Key.");
        setIsSuccess(false);
        setIsOpenPopup(true);
        return;
      }
    }

    // Validation 3: OpenAI key format validation (only if provided)
    if (hasOpenAIKey) {
      const gptKeyPattern = /^sk-(proj-)?[A-Za-z0-9_-]{20,}$/;
      if (!gptKeyPattern.test(rowData.gpt_key.trim())) {
        setMsg("Invalid OpenAI Key format. Key should start with 'sk-' or 'sk-proj-'.");
        setIsSuccess(false);
        setIsOpenPopup(true);
        return;
      }
    }

    const requestBody = {
        name: rowData.project_name || rowData.name,
        description: rowData.description || "",
        // ✅ FIX: Use group_id instead of proj_grp_code
        group_id: rowData.group_id,  
        status: "active",
        proj_key_name: rowData.proj_key_name || null,
        pyannote_key: rowData.pyannote_key || null,
        // proj_tag_code: rowData.proj_tag_code ? [rowData.proj_tag_code] : null,
        gpt_key: rowData.gpt_key ?? '',
        azure_param: rowData.azure_param || null,
        // ✅ ADD THESE TWO LINES:
        openai_key: rowData.gpt_key || null,
        azure_key: rowData.azure_param?.azure_key || null,
        process_type: selectedOption,
        azure_enabled: enableAzure
    };

    try {
        const response = await axios.post(
            `${PROJECT_URL}/projects/create`,
            requestBody,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            }
        );
        console.log("✅ Create response:", response.data);
          if (response.data.message) {
            // Save API keys to sessionStorage for the current project
            if (rowData.gpt_key) {
                sessionStorage.setItem("api_key", rowData.gpt_key);
            }
            
            if (rowData.azure_param?.azure_key) {
                sessionStorage.setItem("azure_param", JSON.stringify({
                    azure_key: rowData.azure_param.azure_key,
                    azure_endpoint: rowData.azure_param.azure_endpoint,
                    azure_deployment_name: rowData.azure_param.azure_deployment_name
                }));
            }
            
            setMsg(response.data.message);
            setIsSuccess(true);
            ReloadData(true); 
            setIsOpenPopup(true);
          }
        // setMsg(response.data.message);
        // setIsSuccess(true);
        // ReloadData(true); 
        // setIsOpenPopup(true);
        
    } catch (error) {
        console.error("❌ Create error:", error);
        console.error("❌ Error response:", error.response?.data);
        const errorMessage = handleApiError(error);
        setMsg(errorMessage);
        setIsSuccess(false);
        setIsOpenPopup(true);
    }
  };

  // const handleEditState = async () => {
  //   console.log("🔵 Starting handleEditState");
  //   console.log("🔵 Current rowData:", rowData);
    
  //   // ✅ CRITICAL FIX: Ensure we have the project_code
  //   const projectCode = rowData.project_code || rowData.id;
    
  //   if (!projectCode) {
  //     console.error("❌ No project code found!");
  //     setMsg("Error: Project code is missing");
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //     return;
  //   }

  //   const requestBody = {
  //     payload: {
  //       name: rowData.project_name || rowData.name,
  //       description: rowData.description || "",
  //       // group_id: rowData.group_id || rowData.proj_grp_code || null,
  //       group_id: rowData.group_id ?? null,
  //       status: rowData.status,
        
  //       // Add all the additional fields
  //       proj_key_name: rowData.proj_key_name || null,
  //       pyannote_key: rowData.pyannote_key || null,
  //       proj_tag_code: selectedTag ? [selectedTag] : null,
  //       gpt_key: rowData.gpt_key || null,
  //       azure_param: rowData.azure_param || null,
  //       process_type: originalKeyGeneration,
  //       azure_enabled: enableAzure
  //     },
  //     userInfo: {
  //       _id: sessionStorage.getItem("userid"),
  //       clientId: sessionStorage.getItem('client'),
  //       role: sessionStorage.getItem('role')
  //     }
  //   };

  //   console.log("🔵 Editing project:", projectCode);
  //   console.log("🔵 Request body:", requestBody);
  //   console.log("🔵 Request URL:", `${PROJECT_URL}/projects/${projectCode}`);

  //   try {
  //     const response = await axios.put(
  //       // `${PROJECT_URL}/projects/${projectCode}`,
  //       `${PROJECT_URL}/${projectCode}`,
  //       requestBody,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         }
  //       }
  //     );
      
  //     console.log("✅ Edit response:", response.data);
      
  //     setIsOpen(false);
  //     setMsg(response.data.message || "Updated successfully");
  //     setIsSuccess(true);
      
  //     // ✅ CRITICAL: Wait for reload to complete before showing popup
  //     console.log("🔵 Calling ReloadData...");
  //     await ReloadData(true);
  //     console.log("✅ ReloadData completed");
      
  //     setIsOpenPopup(true);
      
  //   } catch (error) {
  //     console.error("❌ Edit error:", error);
  //     console.error("❌ Error response:", error.response?.data);
  //     setIsOpen(false);
  //     const errorMessage = handleApiError(error);
  //     setMsg(errorMessage);
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //   }
  // };

  // ✅ FIXED handleEditState with correct URL
  const handleEditState = async () => {
    console.log("🔵 Starting handleEditState");
    console.log("🔵 Current rowData:", rowData);
    
    // ✅ CRITICAL FIX: Ensure we have the project_code
    const projectCode = rowData.project_code || rowData.id;
    
    if (!projectCode) {
      console.error("❌ No project code found!");
      console.error("❌ rowData keys:", Object.keys(rowData));
      console.error("❌ rowData:", rowData);
      setMsg("Error: Project code is missing");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // ✅ FIX: Get user info from JWT token instead of sessionStorage
    const token = localStorage.getItem("access_token");
    if (!token) {
      setMsg("Authentication token not found. Please login again.");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    const user = jwtDecode(token);
    console.log("🔵 Decoded token:", user);

    const requestBody = {
      payload: {
        name: rowData.project_name || rowData.name,
        description: rowData.description || "",
        group_id: rowData.group_id ?? null,
        status: rowData.status,
        
        // Add all the additional fields
        proj_key_name: rowData.proj_key_name || null,
        pyannote_key: rowData.pyannote_key || null,
        proj_tag_code: selectedTag ? [selectedTag] : null,
        gpt_key: rowData.gpt_key ?? '',
        azure_param: rowData.azure_param || null,
        openai_key: rowData.gpt_key || null,
        azure_key: rowData.azure_param?.azure_key || null,
        process_type: originalKeyGeneration,
        azure_enabled: enableAzure
      },
      userInfo: {
        // ✅ FIX: Use decoded JWT token values
        _id: user.sub,                    // JWT uses 'sub' for user ID
        clientId: user.client_id,         // JWT has client_id
        role: user.role                   // JWT has role
      }
    };

  console.log("🔵 Editing project:", projectCode);
  console.log("🔵 Request body:", requestBody);
  console.log("🔵 Request URL:", `${PROJECT_URL}/projects/${projectCode}`);

  // try {
  //   const response = await axios.put(
  //     `${PROJECT_URL}/projects/${projectCode}`,
  //     requestBody,
  //     {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //       }
  //     }
  //   );
    
  //   console.log("✅ Edit response:", response.data);
    
  //   setIsOpen(false);
  //   setMsg(response.data.message || "Updated successfully");
  //   setIsSuccess(true);
    
  //   console.log("🔵 Calling ReloadData...");
  //   await ReloadData(true);
  //   console.log("✅ ReloadData completed");
    
  //   setIsOpenPopup(true);
    
  // } 
  try {
    const response = await axios.put(
      `${PROJECT_URL}/projects/${projectCode}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        }
      }
    );
    
    console.log("✅ Edit response:", response.data);
    
    // Save API keys to sessionStorage for the current project
    if (rowData.gpt_key) {
        sessionStorage.setItem("api_key", rowData.gpt_key);
    }
    
    if (rowData.azure_param?.azure_key) {
        sessionStorage.setItem("azure_param", JSON.stringify({
            azure_key: rowData.azure_param.azure_key,
            azure_endpoint: rowData.azure_param.azure_endpoint,
            azure_deployment_name: rowData.azure_param.azure_deployment_name
        }));
    }
    
    setIsOpen(false);
    setMsg(response.data.message || "Updated successfully");
    setIsSuccess(true);
    
    console.log("🔵 Calling ReloadData...");
    await ReloadData(true);
    console.log("✅ ReloadData completed");
    
    setIsOpenPopup(true);
    
} catch (error) {
    console.error("❌ Edit error:", error);
    console.error("❌ Error response:", error.response?.data);
    console.error("❌ Full error:", JSON.stringify(error, null, 2));
    setIsOpen(false);
    const errorMessage = handleApiError(error);
    setMsg(errorMessage);
    setIsSuccess(false);
    setIsOpenPopup(true);
  }
};

  let [isOpenStatusModal, setIsOpenStatusModal] = useState(false);
  let [modalTitle, setModalTitle] = useState('');

  function closeStatusModal() {
    setIsOpenStatusModal(false);
  }

  // function openStatusModal(e) {
  //   // setRowData(e);
  //   // setModalTitle(`Update Project Status - ${e.project_code}`)
  //   // setIsOpenStatusModal(true);
  //   // ✅ Convert backend status strings to match radio button values
  //   let normalizedStatus;
    
  //   if (e.status === "active" || e.status === 1 || e.status === "1") {
  //     normalizedStatus = "active";
  //   } else if (e.status === "inactive" || e.status === 0 || e.status === "0") {
  //     normalizedStatus = "inactive";
  //   } else if (e.status === "closed" || e.status === 2 || e.status === "2") {
  //     normalizedStatus = "closed";
  //   } else {
  //     normalizedStatus = e.status; // fallback to original value
  //   }
    
  //   setRowData({
  //     ...e,
  //     status: normalizedStatus
  //   });
  //   setModalTitle(`Update Project Status - ${e.project_code}`);
  //   setIsOpenStatusModal(true);
  // }

  function openStatusModal(e) {
    // ✅ Normalize status
    let normalizedStatus;
    
    if (e.status === "active" || e.status === 1 || e.status === "1") {
      normalizedStatus = "active";
    } else if (e.status === "inactive" || e.status === 0 || e.status === "0" || e.status === "hold") {
      normalizedStatus = "inactive";
    } else if (e.status === "closed" || e.status === 2 || e.status === "2") {
      normalizedStatus = "closed";
    } else {
      normalizedStatus = e.status;
    }
    
    setRowData({
      ...e,
      status: normalizedStatus,
      originalStatus: normalizedStatus  // ✅ Store original for validation
    });
    setModalTitle(`Update Project Status - ${e.project_code}`);
    setIsOpenStatusModal(true);
  }

  // const handleStatusState = async () => {
  //   // Validation: Check if status is selected
  //   if (!rowData.status) {
  //     setMsg("Please select a status");
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //     return;
  //   }

  //   // Validation: Check if status actually changed
  // const originalData = data.find(item => item.project_code === rowData.project_code);
  //   if (!originalData) {
  //     setIsOpenStatusModal(false);
  //     setMsg("Project not found");
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //     return;
  //   }

  //   // Normalize both statuses for comparison
  //   const normalizeStatus = (status) => {
  //     if (status === "active" || status === 1 || status === "1") return "active";
  //     if (status === "inactive" || status === 0 || status === "0") return "inactive";
  //     if (status === "closed" || status === 2 || status === "2") return "closed";
  //     return status;
  //   };

  //   const currentStatus = normalizeStatus(rowData.status);
  //   const originalStatus = normalizeStatus(originalData.status);

  //   if (currentStatus === originalStatus) {
  //     setIsOpenStatusModal(false);
  //     setMsg("No changes detected. Status remains the same.");
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //     return;
  //   }

  //   // Prepare request body
  //   const requestBody = {
  //     userInfo: {
  //       _id: sessionStorage.getItem("userid"),
  //       clientId: sessionStorage.getItem('client'),
  //       role: sessionStorage.getItem('role')
  //     },
  //     payload: {
  //       status: currentStatus // Send the normalized status
  //     }
  //   };

  //   // let statusData = { status: rowData.status };
  //   try {
  //     const response = await axios
  //       // .patch(`${PROJECT_URL}/projects/status/${rowData.project_code}`, requestBody, {
  //       .patch(`${PROJECT_URL}/projects/${rowData.project_code}/status`, requestBody, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         },
  //       })
  //       .then((response) => {
  //         setIsOpenStatusModal(false);
  //         setMsg(response.data.message || "Status updated successfully");
  //         setIsSuccess(true);
  //         ReloadData(false);
  //         setIsOpenPopup(true);
  //       });
  //   } catch (error) {
  //     setIsOpenStatusModal(false);
  //     const errorMessage = handleApiError(error);
  //     setMsg(errorMessage);
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //   }
  // };

   const handleStatusState = async () => {
    // Validation: Check if status is selected
    if (!rowData.status) {
      setMsg("Please select a status");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // ✅ Check if trying to reopen closed project
    if (rowData.originalStatus === "closed") {
      setIsOpenStatusModal(false);
      setMsg("⚠️ Cannot change status of closed projects. Once closed, projects cannot be reopened.");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // Validation: Check if status actually changed
    const originalData = data.find(item => item.project_code === rowData.project_code);
    if (!originalData) {
      setIsOpenStatusModal(false);
      setMsg("Project not found");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    const normalizeStatus = (status) => {
      if (status === "active" || status === 1 || status === "1") return "active";
      if (status === "inactive" || status === 0 || status === "0" || status === "hold") return "hold";
      if (status === "closed" || status === 2 || status === "2") return "closed";
      return status;
    };

    const currentStatus = normalizeStatus(rowData.status);
    const originalStatus = normalizeStatus(originalData.status);

    console.log("🔍 Current status:", currentStatus);
    console.log("🔍 Original status:", originalStatus);

    if (currentStatus === originalStatus) {
      setIsOpenStatusModal(false);
      setMsg("No changes detected. Status remains the same.");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // ✅ Warn when closing a project
    if (currentStatus === "closed") {
      const confirmed = window.confirm(
        "⚠️ WARNING: Once you close this project, it cannot be reopened. Are you sure you want to close this project?"
      );
      if (!confirmed) {
        return;
      }
    }

    // Prepare request body
    // const requestBody = {
    //   userInfo: {
    //     _id: sessionStorage.getItem("userid"),
    //     clientId: sessionStorage.getItem('client'),
    //     role: sessionStorage.getItem('role')
    //   },
    //   payload: {
    //     status: currentStatus
    //   }
    // };
    const requestBody = {
      status: currentStatus.toLowerCase()
    };

    // try {
    //   const response = await axios.patch(
    //     // `${PROJECT_URL}/projects/${rowData.project_code}/status`,
    //     `${PROJECT_URL}/${rowData.project_code}/status`,
    //     requestBody,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    //       },
    //     }
    //   );
      
    //   setIsOpenStatusModal(false);
    //   setMsg(response.data.message || "Status updated successfully");
    //   setIsSuccess(true);
    //   // ReloadData(false);
    //   ReloadData(true); 
    //   setIsOpenPopup(true);
      
    // } catch (error) {
    //   setIsOpenStatusModal(false);
    //   const errorMessage = handleApiError(error);
    //   setMsg(errorMessage);
    //   setIsSuccess(false);
    //   setIsOpenPopup(true);
    // }

    try {
      const response = await axios.patch(
        `${PROJECT_URL}/projects/${rowData.project_code}/status`,  // ✅ Changed to /projects/${project_code}/status
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      
      setIsOpenStatusModal(false);
      setMsg(response.data.message || "Status updated successfully");
      setIsSuccess(true);
      ReloadData(true); 
      setIsOpenPopup(true);
      
    } catch (error) {
      console.error("❌ Status update error:", error.response?.data);
      setIsOpenStatusModal(false);
      const errorMessage = handleApiError(error);
      setMsg(errorMessage);
      setIsSuccess(false);
      setIsOpenPopup(true);
    }

  };

  const [isOpenConfirmPopup, setIsOpenConfirmPopup] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState("");

  function closeConfirmPopup() {
    setIsOpenConfirmPopup(false);
  }

  function openConfirmPopup(e) {
    setRowData(e);
    setConfirmationMsg("Are you sure that you want to delete the project?")
    setIsOpenConfirmPopup(true);
  }

  // const handleDeleteState = async () => {
  //   try {
  //     await axios
  //       .delete(
  //         // `${PROJECT_URL}/projects/${rowData.project_code}`,
  //         `${PROJECT_URL}/${rowData.project_code}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //           },
  //         }
  //       )
  //       .then((response) => {
  //         setIsOpenConfirmPopup(false);
  //         setMsg(response.data.message);
  //         setIsSuccess(true);
  //         // ReloadData(false);
  //         ReloadData(true); 
  //         setIsOpenPopup(true);
  //       });
  //   } catch (error) {
  //     setIsOpenConfirmPopup(false);
  //     const errorMessage = handleApiError(error);
  //     setMsg(errorMessage);
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //   }
  // };

  // const statusFilterFn = (row, columnId, filterValue) => {
  //   if (filterValue === '' || filterValue === undefined) {
  //     return true;
  //   }
    
  //   const rowValue = row.getValue(columnId);
    
  //   // Normalize the row value
  //   const normalizeStatus = (status) => {
  //     if (status === "active" || status === 1 || status === "1") return 1;
  //     if (status === "inactive" || status === 0 || status === "0") return 0;
  //     if (status === "closed" || status === 2 || status === "2") return 2;
  //     return status;
  //   };
    
  //   const normalizedRowValue = normalizeStatus(rowValue);
  //   const normalizedFilterValue = normalizeStatus(filterValue);
    
  //   return normalizedRowValue === normalizedFilterValue;
  // };

  const handleDeleteState = async () => {
    try {
      await axios
        .delete(
          `${PROJECT_URL}/projects/${rowData.project_code}`,  // ✅ Changed to /projects/${project_code}
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        )
        .then((response) => {
          setIsOpenConfirmPopup(false);
          setMsg(response.data.message);
          setIsSuccess(true);
          ReloadData(true); 
          setIsOpenPopup(true);
        });
    } catch (error) {
      setIsOpenConfirmPopup(false);
      const errorMessage = handleApiError(error);
      setMsg(errorMessage);
      setIsSuccess(false);
      setIsOpenPopup(true);
    }
  };

  const statusFilterFn = (row, columnId, filterValue) => {
    if (filterValue === '' || filterValue === undefined || filterValue === null) {
      return true;
    }

    const rawValue = row.getValue(columnId);

    // Normalize safely
    const normalizeStatus = (status) => {
      if (status === undefined || status === null) return null;

      const s = String(status).toLowerCase().trim();

      if (s === "active" || s === "1") return 1;
      if (s === "inactive" || s === "0") return 0;
      if (s === "closed" || s === "2") return 2;

      return s; // fallback for future statuses
    };

    const normalizedRowValue = normalizeStatus(rawValue);
    const normalizedFilterValue = normalizeStatus(filterValue);

    return normalizedRowValue === normalizedFilterValue;
  };

  const [sorting, setSorting] = React.useState([]);

  const columns = React.useMemo(
    () => [
      {
        accessorKey: 'index',
        enableColumnFilter: false,
        enableSorting: false,
        size: 50,
        header: '#',
        cell: ({ row }) => <center>{row.index + 1}</center>,
      },
      localStorage.getItem('role') === 'ADMIN' && {
        accessorKey: 'client_name',
        enableColumnFilter: true,
        size: 100,
        header: 'Client'
      },
      {
        accessorKey: 'name',
        enableColumnFilter: false,
        size: 250,
        header: () => <span>Project Name</span>,
        cell: ({ row }) => row.original.name
      },
      {
        accessorKey: 'project_code',
        enableColumnFilter: false,
        size: 250,
        header: () => <span>Project Code</span>,
        cell: ({ row }) => row.original.project_code
      },
      {
        accessorKey: 'group_id',
        enableColumnFilter: true,
        size: 150,
        header: () => <span>Group Code</span>
      },
      // {
      //   accessorKey: 'proj_tag_code',
      //   enableColumnFilter: false,
      //   size: 150,
      //   header: () => <span>Tag Code</span>,
      //   cell: ({ row }) => (
      //     <div className="text-start">
      //       <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-0 m-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
      //         {row.original.proj_tag_code ? JSON.parse(row.original.proj_tag_code?.replace(/'/g, '"'))[0] : ""}
      //       </span>
      //     </div>
      //   ),
      // },
      {
        accessorKey: 'created_at',
        enableColumnFilter: false,
        size: 100,
        header: 'Created Date',
        cell: ({ row }) => (
          <div>{formattedDate(row.original.created_at)}</div>
        )
      },
      {
        // accessorKey: 'created_by',
        accessorKey: 'created_by_name',
        enableColumnFilter: false,
        size: 50,
        header: 'Created By',
      },
      {
        accessorKey: 'status',
        header: 'Status',
        size: 50,
        enableColumnFilter: true,
        filterFn: statusFilterFn,
        // filterFn: 'weakEquals',
        enableSorting: false,
        // cell: ({ row }) => {
        //   return (
        //     <div className='flex justify-center'>
        //       <button
        //         onClick={() => openStatusModal(row.original)}
        //         className={`${row.original.status === 1 ? 'bg-green-300 text-green-900' : row.original.status === 2 ? 'bg-yellow-300 text-yellow-900' : 'bg-red-300 text-red-900'} text-xs w-fit px-2 py-1 font-bold rounded-xl cursor-default lg:cursor-pointer`}
        //       >
        //         {row.original.status === 1 && "Open"}
        //         {row.original.status === 0 && "Hold"}
        //         {row.original.status === 2 && "Close"}
        //       </button>
        //     </div>
        //   )
        // }
        cell: ({ row }) => {
          const status = row.original.status;

          const statusMap = {
            active: { label: "Open", class: "bg-green-300 text-green-900" },
            inactive: { label: "Hold", class: "bg-red-300 text-red-900" },
            closed: { label: "Close", class: "bg-yellow-300 text-yellow-900" }
          };

          const s = statusMap[status] || { label: status, class: "bg-gray-300 text-gray-900" };

          return (
            <div className="flex justify-center">
              <button
                onClick={() => openStatusModal(row.original)}
                className={`${s.class} text-xs w-fit px-2 py-1 font-bold rounded-xl cursor-default lg:cursor-pointer`}
              >
                {s.label}
              </button>
            </div>
          );
        }
      },
      // {
      //   accessorKey: 'id',
      //   header: 'Actions',
      //   size: 50,
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: ({ row }) => {
      //     // const projectGroupMatch = !row.original.proj_grp_code || groups?.find((projectgroup) => projectgroup.proj_grp_code === row.original.proj_grp_code);
      //     const projectGroupMatch = !row.original.group_id || groups?.find((projectgroup) => projectgroup.group_id === row.original.group_id);
      //     const clientMatch = client?.find((client) => client.client_code === row.original.client_code);
          
      //     // ✅ Update status checks to use strings instead of numbers
      //     const isInactive = row.original.status === "inactive" || row.original.status === "hold";
      //     const isClosed = row.original.status === "closed";

      //     return (
      //       <div className='flex gap-2 items-center justify-center'>
      //         <Menu as="div">
      //           <div ref={(el) => (buttonRefs.current[row.original.id] = el)}>
      //             <Menu.Button className="border bg-gray-50 rounded-md p-1 text-blue-800 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
      //               onClick={(e) => {
      //                 e.stopPropagation();
      //                 calculatePosition(row.original.id)
      //               }}
      //             >
      //               <EllipsisHorizontalIcon className="h-4 text-black" />
      //             </Menu.Button>
      //           </div>
      //           <Portal>
      //             <Transition
      //               as={Fragment}
      //               show={activeDropdown === row.original.id}
      //               enter="transition ease-out duration-100"
      //               enterFrom="transform opacity-0 scale-95"
      //               enterTo="transform opacity-100 scale-100"
      //               leave="transition ease-in duration-75"
      //               leaveFrom="transform opacity-100 scale-100"
      //               leaveTo="transform opacity-0 scale-95"
      //             >
      //               <Menu.Items ref={dropdownRef}
      //                 className="absolute z-50 right-8 md:right-12 mt-1 w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      //                 style={{
      //                   top: `${dropdownPosition.top}px`,
      //                 }}
      //               >
      //                 <button
      //                   className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-blue-800 w-full text-sm disabled:text-gray-400"
      //                   // disabled={!clientMatch || !projectGroupMatch || row.original.status === 0 || row.original.status === 2}
      //                   disabled={!clientMatch || !projectGroupMatch || isInactive || isClosed}
      //                   onClick={() => {
      //                     openModal(row.original, "edit")
      //                     setActiveDropdown(null)
      //                   }}
      //                 >
      //                   <PencilIcon className={`h-4 ${(!clientMatch || isInactive || isClosed) ? 'text-gray-400' : 'text-blue-800'} mr-2`} />
      //                   <span>Edit</span>
      //                 </button>
      //                 {localStorage.getItem('role') === 'ADMIN' &&
      //                   <button className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-red-800 w-full text-sm"
      //                     onClick={() => {
      //                       openConfirmPopup(row.original)
      //                       setActiveDropdown(null)
      //                     }}>
      //                     <TrashIcon className='h-4 text-red-800 mr-2' />
      //                     <span>Delete</span>
      //                   </button>}
      //               </Menu.Items>
      //             </Transition>
      //           </Portal>
      //         </Menu>
      //       </div>
      //     )
      //   }
      // },
      // Replace your Actions column cell with this fixed version:
      // {
      //   accessorKey: 'id',
      //   header: 'Actions',
      //   size: 50,
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: ({ row }) => {
      //     const projectGroupMatch = (!row.original.proj_grp_code && !row.original.group_id) || 
      //       groups?.some((projectgroup) => 
      //         projectgroup.proj_grp_code === row.original.proj_grp_code || 
      //         projectgroup.group_id === row.original.group_id
      //       );
          
      //     let clientMatch = true;
          
      //     if (localStorage.getItem('role') === 'ADMIN') {
      //       clientMatch = client?.some((c) => c.client_code === row.original.client_code);
      //     }
          
      //     const currentStatus = row.original.status?.toLowerCase();
      //     const isInactive = currentStatus === "inactive" || currentStatus === "hold";
      //     const isClosed = currentStatus === "closed";
          
      //     const isDisabled = !clientMatch || !projectGroupMatch || isInactive || isClosed;

      //     return (
      //       <div className='flex gap-2 items-center justify-center'>
      //         <Menu as="div">
      //           <div ref={(el) => (buttonRefs.current[row.original.id] = el)}>
      //             <Menu.Button 
      //               className="border bg-gray-50 rounded-md p-1 text-blue-800 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
      //               onClick={(e) => {
      //                 e.stopPropagation();
      //                 calculatePosition(row.original.id);
      //               }}
      //             >
      //               <EllipsisHorizontalIcon className="h-4 text-black" />
      //             </Menu.Button>
      //           </div>
      //           <Portal>
      //             <Transition
      //               as={Fragment}
      //               show={activeDropdown === row.original.id}
      //               enter="transition ease-out duration-100"
      //               enterFrom="transform opacity-0 scale-95"
      //               enterTo="transform opacity-100 scale-100"
      //               leave="transition ease-in duration-75"
      //               leaveFrom="transform opacity-100 scale-100"
      //               leaveTo="transform opacity-0 scale-95"
      //             >
      //               <Menu.Items 
      //                 ref={dropdownRef}
      //                 className="absolute z-50 right-8 md:right-12 mt-1 w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      //                 style={{
      //                   top: `${dropdownPosition.top}px`,
      //                 }}
      //               >
      //                 <button
      //                   className={`flex items-center px-4 py-2 w-full text-sm ${
      //                     isDisabled 
      //                       ? 'text-gray-400 cursor-not-allowed' 
      //                       : 'hover:bg-gray-200 hover:text-blue-800 cursor-pointer'
      //                   }`}
      //                   disabled={isDisabled}
      //                   onClick={() => {
      //                     if (!isDisabled) {
      //                       openModal(row.original, "edit");
      //                       setActiveDropdown(null);
      //                     }
      //                   }}
      //                 >
      //                   <PencilIcon 
      //                     className={`h-4 mr-2 ${isDisabled ? 'text-gray-400' : 'text-blue-800'}`} 
      //                   />
      //                   <span>Edit</span>
      //                 </button>
      //                 {localStorage.getItem('role') === 'ADMIN' && (
      //                   <button 
      //                     className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-red-800 w-full text-sm cursor-pointer"
      //                     onClick={() => {
      //                       openConfirmPopup(row.original);
      //                       setActiveDropdown(null);
      //                     }}
      //                   >
      //                     <TrashIcon className='h-4 text-red-800 mr-2' />
      //                     <span>Delete</span>
      //                   </button>
      //                 )}
      //               </Menu.Items>
      //             </Transition>
      //           </Portal>
      //         </Menu>
      //       </div>
      //     );
      //   }
      // }
      {
        accessorKey: 'project_code',
        header: 'Actions',
        size: 50,
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => {
          console.log(`🎯 Rendering row ${row.original.project_code}:`, {
            status: row.original.status,
            group_id: row.original.group_id,
            id: row.original._id
          });
          const projectGroupMatch = (!row.original.proj_grp_code && !row.original.group_id) || 
            groups?.some((projectgroup) => 
              projectgroup.proj_grp_code === row.original.proj_grp_code || 
              projectgroup.group_id === row.original.group_id
            );
          
          let clientMatch = true;
          
          if (localStorage.getItem('role') === 'ADMIN') {
            clientMatch = client?.some((c) => c.client_code === row.original.client_code);
          }
          
          const currentStatus = row.original.status?.toLowerCase();
          const isInactive = currentStatus === "inactive" || currentStatus === "hold";
          const isClosed = currentStatus === "closed";
          
          const isDisabled = !clientMatch || !projectGroupMatch || isInactive || isClosed;

          return (
            <div className='flex gap-2 items-center justify-center'>
              <Menu as="div" className="relative">
                <Menu.Button 
                  ref={(el) => {
                    if (el) buttonRefs.current[row.original.project_code] = el;
                  }}
                  className="border bg-gray-50 rounded-md p-1 text-blue-800 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    calculatePosition(row.original.project_code);
                  }}
                >
                  <EllipsisHorizontalIcon className="h-4 text-black" />
                </Menu.Button>
                
                <Portal>
                  <Transition
                    as={Fragment}
                    show={activeDropdown === row.original.project_code}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items 
                      ref={dropdownRef}
                      className="absolute z-50 right-8 md:right-12 mt-1 w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                      style={{
                        top: `${dropdownPosition.top}px`,
                      }}
                    >
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`flex items-center px-4 py-2 w-full text-sm ${
                              isDisabled 
                                ? 'text-gray-400 cursor-not-allowed bg-gray-50' 
                                : active 
                                  ? 'bg-gray-200 text-blue-800' 
                                  : 'text-gray-900'
                            }`}
                            disabled={isDisabled}
                            onClick={(e) => {
                              e.preventDefault();
                              if (!isDisabled) {
                                openModal(row.original, "edit");
                                setActiveDropdown(null);
                              }
                            }}
                          >
                            <PencilIcon 
                              className={`h-4 mr-2 ${isDisabled ? 'text-gray-400' : 'text-blue-800'}`} 
                            />
                            <span>Edit</span>
                          </button>
                        )}
                      </Menu.Item>
                      
                      {localStorage.getItem('role') === 'ADMIN' && (
                        <Menu.Item>
                          {({ active }) => (
                            <button 
                              className={`flex items-center px-4 py-2 w-full text-sm ${
                                active ? 'bg-gray-200 text-red-800' : 'text-gray-900'
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                openConfirmPopup(row.original);
                                setActiveDropdown(null);
                              }}
                            >
                              <TrashIcon className='h-4 text-red-800 mr-2' />
                              <span>Delete</span>
                            </button>
                          )}
                        </Menu.Item>
                      )}
                    </Menu.Items>
                  </Transition>
                </Portal>
              </Menu>
            </div>
          );
        }
      }
    ].filter(Boolean),
    [groups, client, activeDropdown, calculatePosition, dropdownPosition.top, openModal, openConfirmPopup, openStatusModal, statusFilterFn]
  );

  const [data, setData] = useState([]);

  const [globalFilter, setGlobalFilter] = React.useState('');
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(initialpageSize);


  const pagination = React.useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  )

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
      pagination,
      globalFilter
    },
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues()
  });

  const tableContainerRef = React.useRef(null);
  // Modify the pagination section
  const pageCount = Math.ceil(data.length / pageSize);
  const pageNumbers = [];

  for (let i = 0; i < pageCount; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (e) => {
    const newPageSize = Number(e.target.value);
    setPageSize(newPageSize);
    setPageIndex(0)
  };

  const { rows } = table.getRowModel();
  // const rowVirtualizer = useVirtualizer({
  //   parentRef: tableContainerRef,
  //   size: rows.length,
  //   overscan: pageSize,
  // });
  // const rowVirtualizer = useVirtualizer({
  //   count: rows.length,
  //   getScrollElement: () => tableContainerRef.current,
  //   estimateSize: () => 50,
  //   overscan: pageSize,
  // });
  // const { virtualItems: virtualRows, totalSize } = rowVirtualizer;
  // const { virtualItems: virtualRows = [], totalSize = 0 } = rowVirtualizer || {};

  // const paddingTop = virtualRows.length > 0 ? virtualRows[0]?.start || 0 : 0;
  // const paddingBottom =
  //   virtualRows.length > 0
  //     ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
  //     : 0;
  // const paddingTop = virtualRows?.length > 0 ? virtualRows[0]?.start || 0 : 0;
  // const paddingBottom =
  //   virtualRows?.length > 0
  //     ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
  //     : 0;

  const renderTableCellIndex = (row) => {
    return (
      table.getFilteredRowModel().rows.indexOf(row) + 1 ||
      table.getSortedRowModel().rows.indexOf(row) + 1 ||
      row.index + 1
    );
  };

  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     axios
  //       .get(`${PROJECT_URL}/projects`, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         },
  //         params: {
  //           client: sessionStorage.getItem('client')
  //         }
  //       })
  //       .then((response) => {
  //         console.log(response.data.data)
  //         setData(response.data.data);
  //       })
  //       .catch((error) => {
  //         const errorMessage = handleApiError(error);
  //         setMsg(errorMessage);
  //         openPopup();
  //       })
  //       .finally(() => {
  //         setTimeout(() => {
  //           setLoader(false);
  //         }, 100);
  //       });
  //   };
  //   const fetchActiveOptions = async () => {
  //     axios
  //       .get(`${PROJECT_URL}/projects/activegrouptag`, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         },
  //         params: {
  //           client: sessionStorage.getItem('client')
  //         }
  //       })
  //       .then((response) => {
  //         setGroups(response.data.data.project_grp_list);
  //         setTags(response.data.data.project_tag_list);
  //       })
  //       .catch((error) => {
  //         const errorMessage = handleApiError(error);
  //         setMsg(errorMessage);
  //         openPopup();
  //       });
  //   };
  //   const fetchClientData = async () => {
  //     axios
  //       // .get(`${API_URL}/clients`, {
  //       .get(`${FUNCTION_BASE_URL}/clients`, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //           "x-resource-group": localStorage.getItem("resource_group"),
  //         },
  //       })
  //       .then((response) => {
  //         const filteredClients = response.data.data.filter(client => client.status === true);
  //         setClient(filteredClients);
  //       })
  //       .catch((error) => {
  //         const errorMessage = handleApiError(error);
  //         setMsg(errorMessage);
  //         openPopup();
  //       })
  //       .finally(() => {
  //         setTimeout(() => {
  //           setLoader(false);
  //         }, 100);
  //       });
  //   };
  //   fetchClientData();
  //   fetchInitialData();
  //   fetchActiveOptions();
  // }, []);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const response = await axios.post(`${PROJECT_URL}/projects/list`, {
          userInfo: {
            _id: sessionStorage.getItem("userid"),
            clientId: sessionStorage.getItem('client'),
            role: sessionStorage.getItem('role')
          },
          payload: {}
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          }
        });
        
        console.log("Projects fetched:", response.data);
        console.log("First project object:", response.data[0]); // ✅ Add this
        console.log("Keys in first project:", Object.keys(response.data[0])); // ✅ Add this
        console.log("PROJECT API RESPONSE:", response.data);
        setData(response.data);
        setData([...response.data]);   // force new reference
        
      } catch (error) {
        const errorMessage = handleApiError(error);
        setMsg(errorMessage);
        openPopup();
      } finally {
        setTimeout(() => {
          setLoader(false);
        }, 100);
      }
    };
    
    const fetchActiveOptions = async () => {
      try {
        // Fetch project groups
        const groupsResponse = await axios.post(`${PROJECT_URL}/projects/groups/list`, {
          userInfo: {
            _id: sessionStorage.getItem("userid"),
            clientId: sessionStorage.getItem('client'),
            role: sessionStorage.getItem('role')
          },
          payload: {}
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          }
        });
        
        // Filter only active groups
        const activeGroups = groupsResponse.data.filter(g => g.status === 'active');
        setGroups(activeGroups);
        
        console.log("Active groups:", activeGroups);
        
      } catch (error) {
        const errorMessage = handleApiError(error);
        setMsg(errorMessage);
        openPopup();
      }
    };
    
    const fetchClientData = async () => {
      try {
        const response = await axios.get(`${FUNCTION_BASE_URL}/clients`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-resource-group": localStorage.getItem("resource_group"),
          },
        });
        
        const filteredClients = response.data.data.filter(client => client.status === true);
        setClient(filteredClients);
        
      } catch (error) {
        const errorMessage = handleApiError(error);
        setMsg(errorMessage);
        openPopup();
      }
    };
    
    // Fetch data in sequence
    const loadAllData = async () => {
      // await fetchClientData();
      if (user.role === "SuperAdmin") {
        await fetchClientData();   // allowed only for SuperAdmin
      }
      await fetchActiveOptions();
      await fetchInitialData();
    };
    
    loadAllData();
  }, []);

  const [clname, setclname] = useState('');

  // const selectModel =()=> (<div className='p-1.5 flex w-fit bg-gray-200 text-xs rounded-2xl'>
  //   <div onClick={()=>{setEnableAzure(!enableAzure);setEditGPT(true);setRowData({...rowData,gpt_key:null,azure_param:null})}} className={`${!enableAzure && 'bg-indigo-700 text-white'} rounded-2xl cursor-default lg:cursor-pointer py-1 px-2`}>OpenAI</div>
  //   <div onClick={()=>{setEnableAzure(!enableAzure);setEditGPT(true);setRowData({...rowData,gpt_key:null})}} className={`${enableAzure &&  'bg-indigo-700 text-white'} rounded-2xl cursor-default lg:cursor-pointer py-1 px-2`}>Azure</div>
  // </div>);

  const selectModel = () => (<div className='p-1.5 flex w-fit bg-gray-200 text-xs rounded-2xl'>
    <div onClick={() => { setEnableAzure(false); setEditGPT(true); }} className={`${!enableAzure && 'bg-indigo-700 text-white'} rounded-2xl cursor-default lg:cursor-pointer py-1 px-2`}>OpenAI</div>
    <div onClick={() => { setEnableAzure(true); setEditGPT(true); }} className={`${enableAzure && 'bg-indigo-700 text-white'} rounded-2xl cursor-default lg:cursor-pointer py-1 px-2`}>Azure</div>
  </div>);
   
  console.log("🎨 Rendering with data:", data);

  return (
    <div className="border rounded-lg bg-white font-GoogleSans tracking-wider overflow-hidden">
      <ConfirmationPopup
        isOpenConfirmPopup={isOpenConfirmPopup}
        confirmationMsg={confirmationMsg}
        closeConfirmPopup={closeConfirmPopup}
        onStateChange={handleDeleteState}
      />
      <Popup
        isOpen={isOpenPopup}
        msg={msg}
        closeModal={closePopup}
        isSuccess={isSuccess}
      />
      <InputModal key={modalKey} isOpen={isOpen} closeModal={closeModal} title={edit === false ? 'Create project' : 'Edit project'} savefn={edit === false ? handleCreateState : handleEditState}
        maxw='max-w-lg'
        inputcls='h-[calc(100dvh-20rem)] pt-3 pb-5 px-4 overflow-y-auto'
        modalInputs={
          <div key={modalContentKey}>
              <div className='space-y-3'>
                {localStorage.getItem('role') === 'ADMIN' &&
                  <div>
                    <label htmlFor="client" className="block text-sm font-medium leading-6 text-gray-900">
                      Client <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="client"
                      name="client"
                      required
                      className="block w-auto md:w-full rounded-md border-0 py-2 mt-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs lg:max-w-full sm:text-sm sm:leading-6"
                      value={rowData.client_code}
                      onChange={(e) => setRowData({ ...rowData, client_code: e.target.value })}
                    >
                      <option value="">Select Client</option>
                      {client.map((item, index) => (
                        <option key={index} value={item.client_code}>
                          {item.client_name}
                        </option>
                      ))}
                    </select>
                  </div>}
                <div>
                  <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                    Project Name <span className="text-red-500">*</span>
                  </label>
                  <input 
                    type="text" 
                    key={`project-name-${edit ? 'edit' : 'create'}-${isOpen ? 'open' : 'closed'}`}
                    className='block w-full rounded-md border border-gray-300 py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6' 
                    value={rowData.project_name || ''}
                    onChange={(e) => setRowData({ ...rowData, project_name: e.target.value })} 
                    required
                  />
                </div>
                <div className='border border-gray-300 rounded-md'>
                  <div className="flex items-center bg-gray-100 rounded-t-md border-b border-gray-300 p-3">
                    <span className="text-sm font-medium text-gray-900">Manual</span>
                  </div>
                  {!enableAzure && <div className='p-3 pt-2'>
                    <label htmlFor="gpt-key" className="flex justify-between items-end text-sm ms-1 pb-1 font-medium leading-6 text-gray-900">
                      <p>GPT Key <span className="text-red-500">*</span></p>{selectModel()}
                    </label>
                    <div className='flex items-center gap-x-2'>
                      <input
                        key={`gpt-key-${edit ? 'edit' : 'create'}-${isOpen ? 'open' : 'closed'}`}
                        type='password'
                        required={!enableAzure}
                        id='gpt-key'
                        value={rowData.gpt_key || ''}
                        onChange={(e) => setRowData({ ...rowData, gpt_key: e.target.value })}
                        disabled={!editGPT}
                        className={`block w-full rounded-md border border-gray-300 disabled:bg-gray-200 py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6`}
                      />
                      {edit && <div className='rounded-md border border-gray-300 p-2 text-blue-600' onClick={() => { setRowData({ ...rowData, gpt_key: '' }); setEditGPT(true); }}><PencilIcon className='h-5 w-auto' /></div>}
                    </div>
                  </div>}
                  {enableAzure &&
                  <>
                    <div className='p-3 pt-2'>
                      <label htmlFor="azure-key" className="flex justify-between items-end text-sm ms-1 pb-1 font-medium leading-6 text-gray-900">
                        <p>Azure Key <span className="text-red-500">*</span></p>{selectModel()}
                      </label>
                      <div className='flex items-center gap-x-2'>
                        <input
                          type='password'
                          required
                          id='azure-key'
                          value={rowData.azure_param?.azure_key}
                          onChange={(e) => setRowData({...rowData, azure_param: {...rowData.azure_param, azure_key: e.target.value}})}
                          className={`block w-full rounded-md border border-gray-300 disabled:bg-gray-200 py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6`}
                        />
                      </div>
                    </div>
                    <div className='p-3 pt-1'>
                      <label htmlFor="azure-endpoint" className="block text-sm ms-1 font-medium leading-6 text-gray-900">
                        Azure Endpoint <span className="text-red-500">*</span>
                      </label>
                      <div className='flex items-center gap-x-2'>
                        <input
                          type='text'
                          required
                          id='azure-endpoint'
                          value={rowData.azure_param?.azure_endpoint}
                          onChange={(e) => setRowData({...rowData, azure_param: {...rowData.azure_param, azure_endpoint: e.target.value}})}
                          className={`block w-full rounded-md border border-gray-300 disabled:bg-gray-200 py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6`}
                        />
                      </div>
                    </div>
                    <div className='p-3 pt-1'>
                      <label htmlFor="azure-deployment-name" className="block text-sm ms-1 font-medium leading-6 text-gray-900">
                        Azure Deployment Name <span className="text-red-500">*</span>
                      </label>
                      <div className='flex items-center gap-x-2'>
                        <input
                          type='text'
                          required
                          id='azure-deployment-name'
                          placeholder="e.g., MeghnadNext-gpt-4o"
                          value={rowData.azure_param?.azure_deployment_name}
                          onChange={(e) => setRowData({...rowData, azure_param: {...rowData.azure_param, azure_deployment_name: e.target.value}})}
                          className={`block w-full rounded-md border border-gray-300 py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6`}
                        />
                      </div>
                    </div>
                    <div className='p-3 pt-1'>
                      <label htmlFor="gpt-key" className="block text-sm ms-1 font-medium leading-6 text-gray-900">
                        GPT Key (Provide OpenAI Key here, While processing on Whisper Transcription / Web Search for Get Ideas)
                      </label>
                      <div className='flex items-center gap-x-2'>
                        <input
                          type='password'
                          required
                          id='gpt-key'
                          value={rowData.gpt_key}
                          onChange={(e) => setRowData({ ...rowData, gpt_key: e.target.value })}
                          disabled={!editGPT}
                          className={`block w-full rounded-md border border-gray-300 disabled:bg-gray-200 py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6`}
                        />
                        {edit && <div className='rounded-md border border-gray-300 p-2 text-blue-600' onClick={() => { setRowData({ ...rowData, gpt_key: '' }); setEditGPT(true); }}><PencilIcon className='h-5 w-auto' /></div>}
                      </div>
                    </div>
                  </>}
                </div>
                <div>
                  <label htmlFor="pyannote-key" className="block text-sm font-medium leading-6 text-gray-900">
                    Pyannote Key
                  </label>
                  <div className='flex items-center gap-x-2'>
                    <input
                      key={`pyannote-key-${edit ? 'edit' : 'create'}-${isOpen ? 'open' : 'closed'}`}
                      type='password'
                      required
                      id='pyannote-key'
                      value={rowData.pyannote_key || ''}
                      onChange={(e) => setRowData({ ...rowData, pyannote_key: e.target.value })}
                      disabled={!editPyannote}
                      className={`block w-full rounded-md border border-gray-300 disabled:bg-gray-200 py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6`}
                    />
                    {edit && <div className='rounded-md border border-gray-300 p-2 text-blue-600' onClick={() => { setRowData({ ...rowData, pyannote_key: '' }); setEditPyannote(true); }}><PencilIcon className='h-5 w-auto' /></div>}
                  </div>
                </div>
                <div>
                  <select
                    id="project"
                    name="project"
                    className="block w-auto md:w-full rounded-md border-0 py-2 mt-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs lg:max-w-full sm:text-sm sm:leading-6"
                    value={rowData.group_id ?? ''}
                    onChange={(e) => setRowData({ ...rowData, group_id: e.target.value })}
                  >
                    <option value="">Select Project Group</option>
                    {groups.map((item, index) => (
                      <option key={index} value={item.group_id}>
                        {item.name || item.proj_grp_name}
                      </option>
                    ))}
                  </select>
                </div>
                {localStorage.getItem('level') === '2' &&
                  <label htmlFor="assign_me" className="text-sm font-medium leading-6 text-gray-900 flex items-center gap-0.5 pt-1">
                    <input
                      id="assign_me"
                      name="assign_me"
                      type="checkbox"
                      checked={assignMe}
                      onChange={(e) => setAssignMe(e.target.checked)}
                      className="h-4 w-4 me-1.5 rounded border text-indigo-600 focus:ring-indigo-600"
                    />Assign Myself to this project
                  </label>
                }
              </div>
          </div>
        }
      />
      {/* <InputModal isOpen={isOpenStatusModal} closeModal={closeStatusModal} title={modalTitle} savefn={handleStatusState}
        modalInputs={
          <div className='flex gap-5'>
            <div className="flex items-center gap-x-2">
              <input
                id="status"
                name="status"
                type="radio"
                // value={1}
                // checked={rowData.status === 1 || rowData.status === "1"}
                value="active"
                checked={rowData.status === "active"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                autoFocus={false}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
              />
              <label htmlFor="push-everything" className="block text-sm font-medium leading-6 text-gray-900">
                Open
              </label>
            </div>
            <div className="flex items-center gap-x-2">
              <input
                id="status"
                name="status"
                type="radio"
                // value={0}
                // checked={rowData.status === 0 || rowData.status === "0"}
                value="inactive"
                checked={rowData.status === "inactive"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                autoFocus={false}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
              />
              <label htmlFor="push-email" className="block text-sm font-medium leading-6 text-gray-900">
                Hold
              </label>
            </div>
            <div className="flex items-center gap-x-2">
              <input
                id="status"
                name="status"
                type="radio"
                // value={2}
                // checked={rowData.status === 2 || rowData.status === "2"}
                value="closed"
                checked={rowData.status === "closed"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                autoFocus={false}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
              />
              <label htmlFor="push-email" className="block text-sm font-medium leading-6 text-gray-900">
                Close
              </label>
            </div>
          </div>
        }
      /> */}
      {/* <InputModal isOpen={isOpenStatusModal} closeModal={closeStatusModal} title={modalTitle} savefn={handleStatusState}
        modalInputs={
          <div className='flex gap-5'>
            <div className="flex items-center gap-x-2">
              <input
                id="status-active"
                name="status"
                type="radio"
                value="active"
                checked={rowData.status === "active"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                disabled={rowData.originalStatus === "closed"}
                autoFocus={false}
                className={`h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none ${
                  rowData.originalStatus === "closed" ? 'cursor-not-allowed opacity-50' : ''
                }`}
              />
              <label 
                htmlFor="status-active" 
                className={`block text-sm font-medium leading-6 text-gray-900 ${
                  rowData.originalStatus === "closed" ? 'text-gray-400 cursor-not-allowed' : ''
                }`}
              >
                Open
              </label>
            </div>
            
            <div className="flex items-center gap-x-2">
              <input
                id="status-hold"
                name="status"
                type="radio"
                value="inactive"
                checked={rowData.status === "inactive"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                disabled={rowData.originalStatus === "closed"}
                autoFocus={false}
                className={`h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none ${
                  rowData.originalStatus === "closed" ? 'cursor-not-allowed opacity-50' : ''
                }`}
              />
              <label 
                htmlFor="status-hold" 
                className={`block text-sm font-medium leading-6 text-gray-900 ${
                  rowData.originalStatus === "closed" ? 'text-gray-400 cursor-not-allowed' : ''
                }`}
              >
                Hold
              </label>
            </div>
            
            <div className="flex items-center gap-x-2">
              <input
                id="status-closed"
                name="status"
                type="radio"
                value="closed"
                checked={rowData.status === "closed"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                disabled={rowData.originalStatus === "closed"}
                autoFocus={false}
                className={`h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none ${
                  rowData.originalStatus === "closed" ? 'cursor-not-allowed opacity-50' : ''
                }`}
              />
              <label 
                htmlFor="status-closed" 
                className={`block text-sm font-medium leading-6 text-gray-900 ${
                  rowData.originalStatus === "closed" ? 'text-gray-400 cursor-not-allowed' : ''
                }`}
              >
                Close
              </label>
            </div>
          </div>
        }
      /> */}
      <InputModal isOpen={isOpenStatusModal} closeModal={closeStatusModal} title={modalTitle} savefn={handleStatusState}
        modalInputs={
          <div className='space-y-2'>
            {/* Warning message if project is closed */}
            {rowData.originalStatus === "closed" && (
              <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3 text-sm text-yellow-800">
                ⚠️ This project is closed and cannot be reopened or changed to hold status.
              </div>
            )}
            
            <div className='flex gap-5'>
              <div className="flex items-center gap-x-2">
                <input
                  id="status-active"
                  name="status"
                  type="radio"
                  value="active"
                  checked={rowData.status === "active"}
                  onChange={(e) =>
                    setRowData({
                      ...rowData,
                      status: e.target.value,
                    })
                  }
                  disabled={rowData.originalStatus === "closed"}
                  autoFocus={false}
                  className={`h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none ${
                    rowData.originalStatus === "closed" ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                  }`}
                />
                <label 
                  htmlFor="status-active" 
                  className={`block text-sm font-medium leading-6 ${
                    rowData.originalStatus === "closed" ? 'text-gray-400 cursor-not-allowed' : 'text-gray-900 cursor-pointer'
                  }`}
                  onClick={(e) => {
                    if (rowData.originalStatus === "closed") {
                      e.preventDefault();
                    }
                  }}
                >
                  Open
                </label>
              </div>
              
              <div className="flex items-center gap-x-2">
                <input
                  id="status-hold"
                  name="status"
                  type="radio"
                  value="inactive"
                  checked={rowData.status === "inactive"}
                  onChange={(e) =>
                    setRowData({
                      ...rowData,
                      status: e.target.value,
                    })
                  }
                  disabled={rowData.originalStatus === "closed"}
                  autoFocus={false}
                  className={`h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none ${
                    rowData.originalStatus === "closed" ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                  }`}
                />
                <label 
                  htmlFor="status-hold" 
                  className={`block text-sm font-medium leading-6 ${
                    rowData.originalStatus === "closed" ? 'text-gray-400 cursor-not-allowed' : 'text-gray-900 cursor-pointer'
                  }`}
                  onClick={(e) => {
                    if (rowData.originalStatus === "closed") {
                      e.preventDefault();
                    }
                  }}
                >
                  Hold
                </label>
              </div>
              
              <div className="flex items-center gap-x-2">
                <input
                  id="status-closed"
                  name="status"
                  type="radio"
                  value="closed"
                  checked={rowData.status === "closed"}
                  onChange={(e) =>
                    setRowData({
                      ...rowData,
                      status: e.target.value,
                    })
                  }
                  disabled={rowData.originalStatus === "closed"}
                  autoFocus={false}
                  className={`h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none ${
                    rowData.originalStatus === "closed" ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                  }`}
                />
                <label 
                  htmlFor="status-closed" 
                  className={`block text-sm font-medium leading-6 ${
                    rowData.originalStatus === "closed" ? 'text-gray-400 cursor-not-allowed' : 'text-gray-900 cursor-pointer'
                  }`}
                  onClick={(e) => {
                    if (rowData.originalStatus === "closed") {
                      e.preventDefault();
                    }
                  }}
                >
                  Close
                </label>
              </div>
            </div>
          </div>
        }
      />

      <div className='flex justify-between m-3 gap-2'>
        <div>
          <DebouncedInput
            value={globalFilter ?? ''}
            onChange={value => setGlobalFilter(String(value))}
            placeholder="Search..."
          />
        </div>
        <div className='flex gap-2'>
          <button className="rounded-md cursor-default lg:cursor-pointer p-2 inline-flex text-sm border-gray-300 border" onClick={() => ReloadData(true)}>
            <ArrowPathIcon className='h-5 text-green-700' />
          </button>
          <Menu as="div" className="relative">
            <div>
              <Menu.Button className="relative justify-center border border-gray-300 rounded-md p-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer">
                <span className="absolute -inset-1.5" />
                <FunnelIcon className="h-5 w-auto" />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="fixed right-8 z-30 mt-3 w-fit px-2 pb-2 space-y-3 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div>
                  {data.length > 0 &&
                    table
                      .getHeaderGroups()
                      .map((headerGroup) => (
                        <div
                          key={headerGroup.id}
                          className="space-y-1"
                        >
                          {headerGroup.headers.map(
                            (header) => (
                              <div
                                key={header.id}
                              >
                                {header.column.getCanFilter() &&
                                  header.column.id === "status" ? (
                                  <div>
                                    <label
                                      htmlFor="push-everything"
                                      className="block text-xs font-bold tracking-widest leading-6 text-gray-400 ps-1"
                                    >
                                      Status
                                    </label>
                                    <ProjectStatusFilter
                                      column={
                                        header.column
                                      }
                                      table={
                                        table
                                      }
                                    />
                                  </div>
                                ) : null}
                                {header.column.getCanFilter() &&
                                  (header.column.id === "client_name" ||
                                    header.column.id === "group_id") ? (
                                  <div>
                                    <label
                                      htmlFor="push-everything"
                                      className="block text-xs font-medium tracking-widest leading-6 text-gray-400 ps-1"
                                    >
                                      {header.column.id === "client_name" ? "Client" : ""}
                                      {header.column.id === "group_id" ? "Group Code" : ""}
                                    </label>
                                    <SelectSelectedClientBasedTextFilter
                                      column={header.column}
                                      data={data}
                                      clname={clname}
                                      setclname={setclname}
                                    />
                                  </div>
                                ) : null}
                              </div>
                            )
                          )}
                        </div>
                      ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
          <button className="rounded-md cursor-default lg:cursor-pointer p-2 inline-flex text-sm border-gray-300 border" onClick={() => openModal({}, 'create')}>
            <PlusCircleIcon className='h-5' />
          </button>
        </div>
      </div>
      {Loader && <FetchingDataLoader />}
      {!Loader &&
        <>
          <div ref={tableContainerRef} className='resp-table-h border-y overflow-auto relative'>
            <table className='flex-inline w-full border-collapse'>
              <thead className='bg-gray-100'>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                      return (
                        <th
                          className='border p-2 whitespace-nowrap'
                          key={header.id}
                          colSpan={header.colSpan}
                          style={{ width: header.getSize() }}
                        >
                          {header.isPlaceholder ? null : (
                            <>
                              <div
                                className={`${header.column.getCanSort()
                                  ? 'cursor-pointer select-none justify-start'
                                  : 'justify-center'
                                  } flex`}
                                onClick={header.column.getToggleSortingHandler()}
                              >
                                {flexRender(
                                  header.column.columnDef.header,
                                  header.getContext()
                                )}
                                {{
                                  asc: ' 🔼',
                                  desc: ' 🔽',
                                }[header.column.getIsSorted()] || null}
                              </div>
                            </>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              <tbody>
                {
                  rows.length === 0 ?
                    (
                      <tr>
                        <td className='border p-2' colSpan={table.getHeaderGroups()[0].headers.length} style={{ textAlign: 'center' }}>
                          No Data Found
                        </td>
                      </tr>
                    )
                    :
                    // (
                    //   <>
                    //     {paddingTop > 0 && (
                    //       <tr>
                    //         <td className='border p-2' style={{ height: `${paddingTop}px` }} />
                    //       </tr>
                    //     )}
                    //     {virtualRows.map((virtualRow) => {
                    //       const row = rows[virtualRow.index];
                    //       return (
                    //         <tr key={row.id}>
                    //           {row.getVisibleCells().map((cell) => {
                    //             return (
                    //               <td className='border p-2 whitespace-nowrap' key={cell.id}>
                    //                 {cell.column.id === "index" && (
                    //                   <center>{renderTableCellIndex(row)}</center>
                    //                 )}
                    //                 {cell.column.id !== "index" &&
                    //                   flexRender(
                    //                     cell.column
                    //                       .columnDef
                    //                       .cell,
                    //                     cell.getContext()
                    //                   )}
                    //               </td>
                    //             );
                    //           })}
                    //         </tr>
                    //       );
                    //     })}
                    //     {paddingBottom > 0 && (
                    //       <tr>
                    //         <td className='border p-2' style={{ height: `${paddingBottom}px` }} />
                    //       </tr>
                    //     )}
                    //   </>
                    // )
                    (
                      rows.map((row) => (
                        <tr key={row.id}>
                          {row.getVisibleCells().map((cell) => (
                            <td className='border p-2 whitespace-nowrap' key={cell.id}>
                              {cell.column.id === "index" ? (
                                <center>{renderTableCellIndex(row)}</center>
                              ) : (
                                flexRender(cell.column.columnDef.cell, cell.getContext())
                              )}
                            </td>
                          ))}
                        </tr>
                      ))
                    )
                }

              </tbody>
            </table>
          </div>
          {
            rows.length > 0 && (
              <div className='flex gap-1 flex-wrap md:flex-nowrap justify-between flex-row-reverse m-3'>
                {/* <nav className="isolate inline-flex -space-x-px mx-2 md:m-0 bg-white rounded-md md:shadow-sm text-gray-900" aria-label="Pagination">
                  <button title='First Page' onClick={() => setPageIndex(0)}
                    className="relative inline-flex items-center rounded-l-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                  >
                    <ChevronDoubleLeftIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                  <button title='Previous Page'
                    onClick={() => setPageIndex(pageIndex - 1)}
                    disabled={pageIndex === 0}
                    aria-current="page"
                    className="relative inline-flex items-center px-2 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                  >
                    <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                  {pageNumbers.length === 1 &&
                    <button
                      className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                      key={1}
                      onClick={() => setPageIndex(0)}
                    >
                      {1}
                    </button>
                  }
                  {pageNumbers.length > 1 && pageNumbers.map((pageNumber, index) => {
                    if (pageNumber === 0 || pageNumber === table.getPageCount() - 1 || Math.abs(pageNumber - pageIndex) <= 1) {
                      if (table.getPageCount() !== 0 && table.getPageCount() === 1 && table.getPageCount() === pageNumber) {
                        return (
                          <button
                            className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                            key={index}
                            onClick={() => setPageIndex(pageNumber - 1)}
                          >
                            {pageNumber}
                          </button>
                        );
                      }
                      else if (table.getPageCount() !== 1 && table.getPageCount() > pageNumber) {
                        return (
                          <button
                            className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                            key={index}
                            onClick={() => setPageIndex(pageNumber)}
                          >
                            {pageNumber + 1}
                          </button>
                        );
                      }
                      else if (table.getPageCount() === 0 && table.getPageCount() === pageNumber) {
                        return (
                          <button
                            className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
                            key={index}
                            onClick={() => setPageIndex(0)}
                          >
                            {1}
                          </button>
                        );
                      }
                    } else if (pageNumber === 1 || pageNumber === table.getPageCount() - 2) {
                      return <button className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0' key={index}>...</button>;
                    }
                    return null;
                  })}
                  <button title='Next Page' onClick={() => setPageIndex(pageIndex + 1)} disabled={pageIndex === (table.getPageCount() - 1)}
                    className="relative inline-flex items-center px-2 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                  >
                    <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                  <button title='Last Page' onClick={() => setPageIndex(table.getPageCount() - 1)}
                    className="relative inline-flex items-center rounded-r-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                  >
                    <ChevronDoubleRightIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                </nav> */}
                <Pagination
                  pageIndex={pageIndex}
                  setPageIndex={setPageIndex}
                  pageNumbers={pageNumbers}
                  pageCount={table.getPageCount()}
                />
                <PageSizeDropdown
                  dataLength={table.getPrePaginationRowModel().rows.length}
                  pageSize={pageSize}
                  handlePageChange={handlePageChange}
                  totalRows={table.getPrePaginationRowModel().rows.length}
                />
              </div>
            )
          }
        </>
      }
    </div >
  );
}